import styles from "./index.module.less";

export function Shield({
  record,
  contentType,
  onCancelShield,
}: {
  record: IPin;
  contentType: string;
  onCancelShield: () => void;
}) {
  return (
    <div className={styles.shield}>
      <div className={styles.text}>
        <div>已收到你的反馈，谢谢！</div>
        <div>我们将为你持续优化推荐结果</div>
      </div>
      <div className={styles.linkContainer}>
        <a
          className={styles.link}
          data-gd-click="button_click"
          data-button-name="取消屏蔽"
          data-content-id={record?.pin_id}
          data-board-id={record?.board_id}
          data-file-id={record?.file_id}
          data-material-id={record?.file_material?.material_id}
          data-content-type={contentType}
          data-report-reason={record?.shield_reason}
          data-unique-id={record?.pin_id}
          onClick={onCancelShield}
          data-ext={JSON.stringify(record?.ext)}
        >
          取消屏蔽
        </a>
      </div>
    </div>
  );
}
